exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".left-bar-leftBar-2fykA{left:0;width:200px;height:100%;display:flex;padding-left:8px}", ""]);

// Exports
exports.locals = {
	"leftBar": "left-bar-leftBar-2fykA"
};